import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { getContactUsDetails, getLenderInfo, horizontalStepperRepo, isFromJupiter, } from '../../../configs/utils';
import { contactUs, failureAction, goBack, navNext, onLoadAction, onModalCloseAction, successAction, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
export const template = (stepper, height, lenderInfo, isJupiter, contactUsDetails) => ({
    layout: {
        id: ROUTE.DSP_KFS,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'dspKfsPage', type: WIDGET.DSP_KFS_PAGE
            }
        ],
    },
    datastore: {
        dspKfsPage: {
            height: height,
            successAction: {
                routeId: ROUTE.DSP_KFS,
                type: ACTION.SUCCESS_ACTION,
                payload: {}
            },
            failureAction: {
                routeId: ROUTE.DSP_KFS,
                type: ACTION.FAILURE_ACTION,
                payload: {}
            },
            contactUsAction: {
                routeId: ROUTE.DSP_KFS,
                type: ACTION.NAV_CONTACT_US,
                payload: {}
            },
            lenderInfo: lenderInfo,
            stepperProps: stepper,
            isJupiter: isJupiter,
            loading: true,
            backAction: {
                routeId: ROUTE.DSP_KFS,
                type: ACTION.GO_BACK,
                payload: {}
            },
            navNextAction: {
                routeId: ROUTE.DSP_KFS,
                type: ACTION.NAV_NEXT_ACTION,
                payload: {}
            },
            onModalCloseAction: {
                routeId: ROUTE.DSP_KFS,
                type: ACTION.ON_MODAL_CLOSE_ACTION,
                payload: {}
            },
            showWaitingForResponse: false,
            contactUsDetails: contactUsDetails
        }
    },
});
export const dspKfsMF = {
    onLoad: async ({ network, getHeight }, { setIsUserLoggedIn }) => {
        const userResponse = await network.post(api.userContext, {}, {
            headers: await getAppHeader(),
        });
        const contactUsDetails = await getContactUsDetails();
        await SharedPropsService.setUser(userResponse.data);
        const lenderInfo = await getLenderInfo(network);
        const stepper = await horizontalStepperRepo(network);
        setIsUserLoggedIn(userResponse.data);
        const isJupiter = await isFromJupiter();
        return Promise.resolve(template(stepper, getHeight(), lenderInfo, isJupiter, contactUsDetails));
    },
    action: {
        routeId: ROUTE.DSP_KFS,
        type: ACTION.ON_LOAD,
        payload: {}
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NAV_CONTACT_US]: contactUs,
        [ACTION.NAV_NEXT_ACTION]: navNext,
        [ACTION.SUCCESS_ACTION]: successAction,
        [ACTION.FAILURE_ACTION]: failureAction,
        [ACTION.ON_MODAL_CLOSE_ACTION]: onModalCloseAction,
        [ACTION.ON_LOAD]: onLoadAction,
    },
};
